import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/api/client";
import { toast } from "sonner";
import { Mail } from "lucide-react";

export default function NewsletterForm({ variant = "inline", testid = "newsletter" }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email, source: variant });
      setEmail("");
      if (data.already) {
        toast.success("Já estava subscrito. Obrigada!");
        setBusy(false);
      } else {
        navigate("/obrigado?type=newsletter");
      }
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail) || "Não foi possível subscrever.");
      setBusy(false);
    }
  };

  return (
    <form onSubmit={onSubmit} data-testid={`${testid}-form`} className="w-full">
      <div className="flex flex-col sm:flex-row gap-2">
        <div className="flex-1 relative">
          <Mail className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-stone-400" />
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="o.seu@email.pt"
            data-testid={`${testid}-input`}
            className="w-full rounded-full border border-stone-200 bg-white pl-10 pr-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#103C4A]/30"
          />
        </div>
        <button type="submit" disabled={busy} data-testid={`${testid}-submit`} className="btn-primary whitespace-nowrap">
          {busy ? "A subscrever..." : "Subscrever"}
        </button>
      </div>
      <p className="mt-2 text-xs text-stone-500">Um email semanal, curto, com os melhores imóveis da semana. Zero spam.</p>
    </form>
  );
}
